import { render, staticRenderFns } from "./DeleteMaterialCategoryConfirmation.vue?vue&type=template&id=1b5100e8"
import script from "./DeleteMaterialCategoryConfirmation.vue?vue&type=script&lang=js"
export * from "./DeleteMaterialCategoryConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports